import { History } from "history";

import {
  ADD_GOVERNORATE,
  ADD_GOVERNORATE_ERROR,
  ADD_GOVERNORATE_SUCCESS,
  AddGovernorateAction,
  AddGovernorateErrorAction,
  AddGovernorateSuccessAction,
  DELETE_GOVERNORATE,
  DELETE_GOVERNORATE_CONSENT,
  DELETE_GOVERNORATE_ERROR,
  DELETE_GOVERNORATE_SUCCESS,
  DeleteGovernorateAction,
  DeleteGovernorateConsentAction,
  DeleteGovernorateErrorAction,
  DeleteGovernorateSuccessAction,
  GET_GOVERNORATE,
  GET_GOVERNORATES,
  GET_GOVERNORATES_ERROR,
  GET_GOVERNORATES_SUCCESS,
  GET_GOVERNORATE_ERROR,
  GET_GOVERNORATE_SELECT_LIST,
  GET_GOVERNORATE_SELECT_LIST_ERROR,
  GET_GOVERNORATE_SELECT_LIST_SUCCESS,
  GET_GOVERNORATE_SUCCESS,
  GetGovernorateAction,
  GetGovernorateErrorAction,
  GetGovernorateSelectListAction,
  GetGovernorateSelectListErrorAction,
  GetGovernorateSelectListSuccessAction,
  GetGovernorateSuccessAction,
  GetGovernoratesAction,
  GetGovernoratesErrorAction,
  GetGovernoratesSuccessAction,
  UPDATE_GOVERNORATE,
  UPDATE_GOVERNORATE_ERROR,
  UPDATE_GOVERNORATE_SUCCESS,
  UpdateGovernorateAction,
  UpdateGovernorateErrorAction,
  UpdateGovernorateSuccessAction,
} from "./actionTypes";
import {
  CreateGovernorateRequest,
  GovernorateDto,
  PaginateQuery,
  UpdateGovernorateRequest,
} from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";

//#region Get Governorates

export const getGovernorates = (
  request: PaginateQuery,
  history: History
): GetGovernoratesAction => {
  return {
    type: GET_GOVERNORATES,
    payload: { request, history },
  };
};

export const getGovernoratesSuccess = (
  response: Paginated<GovernorateDto>
): GetGovernoratesSuccessAction => {
  return {
    type: GET_GOVERNORATES_SUCCESS,
    payload: response,
  };
};

export const getGovernoratesError = (
  error: any
): GetGovernoratesErrorAction => {
  return {
    type: GET_GOVERNORATES_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Governorate

export const getGovernorate = (
  id: string,
  history: History
): GetGovernorateAction => {
  return {
    type: GET_GOVERNORATE,
    payload: { id, history },
  };
};

export const getGovernorateSuccess = (
  response: GovernorateDto
): GetGovernorateSuccessAction => {
  return {
    type: GET_GOVERNORATE_SUCCESS,
    payload: response,
  };
};

export const getGovernorateError = (error: any): GetGovernorateErrorAction => {
  return {
    type: GET_GOVERNORATE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Governorate Select List

export const getGovernorateSelectList = (
  history: History
): GetGovernorateSelectListAction => {
  return {
    type: GET_GOVERNORATE_SELECT_LIST,
    payload: { history },
  };
};

export const getGovernorateSelectListSuccess = (
  response: SelectListDto[]
): GetGovernorateSelectListSuccessAction => {
  return {
    type: GET_GOVERNORATE_SELECT_LIST_SUCCESS,
    payload: response,
  };
};

export const getGovernorateSelectListError = (
  error: any
): GetGovernorateSelectListErrorAction => {
  return {
    type: GET_GOVERNORATE_SELECT_LIST_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Governorate

export const addGovernorate = (
  request: CreateGovernorateRequest,
  history: History
): AddGovernorateAction => {
  return {
    type: ADD_GOVERNORATE,
    payload: { request, history },
  };
};

export const addGovernorateSuccess = (): AddGovernorateSuccessAction => {
  return {
    type: ADD_GOVERNORATE_SUCCESS,
    payload: null,
  };
};

export const addGovernorateError = (error: any): AddGovernorateErrorAction => {
  return {
    type: ADD_GOVERNORATE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Governorate

export const updateGovernorate = (
  id: string,
  request: UpdateGovernorateRequest,
  history: History
): UpdateGovernorateAction => {
  return {
    type: UPDATE_GOVERNORATE,
    payload: { id, request, history },
  };
};

export const updateGovernorateSuccess = (): UpdateGovernorateSuccessAction => {
  return {
    type: UPDATE_GOVERNORATE_SUCCESS,
    payload: null,
  };
};

export const updateGovernorateError = (
  error: any
): UpdateGovernorateErrorAction => {
  return {
    type: UPDATE_GOVERNORATE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Governorate

export const deleteGovernorateConsent = (
  id: string
): DeleteGovernorateConsentAction => {
  return {
    type: DELETE_GOVERNORATE_CONSENT,
    payload: id,
  };
};

export const deleteGovernorate = (
  id: string,
  history: History
): DeleteGovernorateAction => {
  return {
    type: DELETE_GOVERNORATE,
    payload: { id, history },
  };
};

export const deleteGovernorateSuccess = (): DeleteGovernorateSuccessAction => {
  return {
    type: DELETE_GOVERNORATE_SUCCESS,
    payload: null,
  };
};

export const deleteGovernorateError = (
  error: any
): DeleteGovernorateErrorAction => {
  return {
    type: DELETE_GOVERNORATE_ERROR,
    payload: error,
  };
};

//#endregion
